Elements = require './elements'
Singleton = require '../../pattern/singleton'
AnimationSequence = require '../../components/animation-sequence'
AboutSequence = require './anime-sequence/about-sequence'
serviceSequence = require './anime-sequence/service-sequence'
workflowSequence = require './anime-sequence/workflow-sequence'
worksSequence = require './anime-sequence/works-sequence'
recruitSequence = require './anime-sequence/recruit-sequence'
contactSequence = require './anime-sequence/contact-sequence'
{ forEach, map, clone, size } = require 'lodash'
Data = require '../data'

module.exports =
class FirstAnime extends Singleton

  constructor: ->
    super

    @$window = Elements.$window
      .one 'pagesLoaded', @onPagesLoaded

    @runSequence  = []
    @getSequences = []

    @directory = clone Data.directory
    @directory.shift()

  onPagesLoaded: =>
    forEach @directory, (val, i) =>
      { getSequences, getInitialVals } =
        switch val
          when '/about/'    then new AboutSequence
          when '/service/'  then new serviceSequence
          when '/workflow/' then new workflowSequence
          when '/works/'    then new worksSequence
          when '/recruit/'  then new recruitSequence
          when '/contact/'  then new contactSequence
      { initialize, runSequence } = new AnimationSequence
      initialize getInitialVals()
      @getSequences[i] = getSequences
      @runSequence[i]  = runSequence

  start: (target) ->
    sequences    = @getSequences[target]()
    sequencesLen = size sequences
    count        = 0
    forEach sequences, (sequence, name, i) =>
      @runSequence[target] sequences, name, null, =>
        if (sequencesLen - 1) <= count
          @$window.trigger 'firstAnimated', [target]
        else
          count++



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/first-anime.coffee